export default __webpack_public_path__ + "static/media/AprilSATPrepOptimized.d5dbac07.jp2";